import { Box, Button, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"
import { PropsLeft } from "./types"
import { DinamicForm } from "../../../../../../../../../../components/dinamicForm"
import { DateModalSimple } from "../../../../../../../../../../components/dinamicForm/dateModal"
import { useEffect, useMemo, useState } from "react"
import dayjs from "dayjs"
import { DestinationType } from "../../enums/destinationType"
import { generalDisabled } from "../../../../../../../../../../utils/validate/validate"
import { InputModal } from "../inputModal"
import { CustomTable } from "../../../../../../../../../../components"
import { CustomeIconButton } from "../../../../../../../../../../components/customeIconButton"
import { icons } from "../../../../../../../../../../utils/icons"
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { toUnitTimeZone } from "../../../../../../../../../../utils/methods/calcDate"
import { MapActivity } from "../../../../../mapActivity"
import { getLocalStorage } from "../../../../../../../../../../utils/crud/crypt"
import { Local } from "../../types"
import { Roles } from "../../../../../../../../../../utils/enums"


export const LeftActivityForm = (props: PropsLeft) => {

    dayjs.extend(utc);
    dayjs.extend(timezone);

    const styles = useStyles()
    const { t } = useTranslation()
    const [openUnityModal, setOpenUnityModal] = useState(false)
    const [openDestinatioModal, setOpenDestinatioModal] = useState(false)



    const disableActivityForm = useMemo(() => generalDisabled(props.inputActivity, props.dataActivity), [props.dataActivity, props.inputActivity])
    //const disableDestinationForm = useMemo(() => generalDisabled(props.inputDestination, props.dataDestination), [props.dataDestination])
    const [editInEdit, setEditInEdit] = useState<boolean>(false)
    const [errors, setErrors] = useState<Record<string, string>>({})
    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [oldTypeDestination, setOldTypeDestination] = useState<DestinationType>()
    const [disableName, setDisableName] = useState(false)
    const [value, setValue] = useState('')
    const company: Local = getLocalStorage()

    const handleAddActivity = () => {
        props.handleActivities({
            id: String(Math.floor(Math.random() * 1000) + 1),
            error: false,
            open: props.dataActivity?.open ? String(props.dataActivity.open) : undefined,
            name: props.dataActivity?.title ? String(props.dataActivity.title) : null,
            type: props.dataActivity?.typeOfActivity ? {
                label: String((props.dataActivity.typeOfActivity.label)),
                value: String((props.dataActivity.typeOfActivity.value)),
                openField: (props.dataActivity.typeOfActivity.openField)
            } : null,
            startDate: props.dataActivity?.to ? dayjs(props.dataActivity?.from) : undefined,
            endDate: props.dataActivity?.to ? dayjs(props.dataActivity?.to) : undefined,
            destination: {
                id: props.destinationFinal?.id ? Number(props.destinationFinal?.id) : null,
                latitude: Number(props.destinationFinal?.latitude ?? 0),
                longitude: Number(props.destinationFinal?.longitude ?? 0),
                name: String(props.destinationFinal?.name ?? ''),
                type: props.destinationFinal?.type ?? DestinationType.DESTINATION,
                timeZone: props.destinationFinal?.timeZone
            },
            free: !!props.dataActivity?.free
        })
        props.handleDataActivity()
        props.handleChangeCrud({ name: 'from', date: dayjs() })
        props.setDefaultValues({ from: dayjs(), to: null })
        props.setDestinationFinal(undefined)
    }

    const handleEditActivity = () => {
        setEditInEdit(false)
        props.editActivity(
            {
                id: String(Math.floor(Math.random() * 1000) + 1),
                error: false,
                open: props.dataActivity?.open ? String(props.dataActivity.open) : undefined,
                name: props.dataActivity?.title ? String(props.dataActivity.title) : null,
                type: props.dataActivity?.typeOfActivity ? {
                    label: String((props.dataActivity.typeOfActivity.label)),
                    value: String((props.dataActivity.typeOfActivity.value)),
                    openField: (props.dataActivity.typeOfActivity.openField)
                } : null,
                startDate: props.dataActivity?.to ? dayjs(props.dataActivity?.from) : undefined,
                endDate: props.dataActivity?.to ? dayjs(props.dataActivity?.to) : undefined,
                destination: {
                    id: props.destinationFinal?.id ? Number(props.destinationFinal?.id) : null,
                    latitude: Number(props.destinationFinal?.latitude ?? 0),
                    longitude: Number(props.destinationFinal?.longitude ?? 0),
                    name: String(props.destinationFinal?.name ?? ''),
                    type: props.destinationFinal?.type ?? DestinationType.DESTINATION,
                    timeZone: props.destinationFinal?.timeZone
                },
                free: !!props.dataActivity?.free
            },
            String(props.idToEdit)
        )
        props.handleDataActivity()
        props.handleChangeCrud({ name: 'from', date: dayjs() })
        props.setDefaultValues({ from: dayjs(), to: null })
        props.setIdToEdit(0)
        props.setDestinationFinal(undefined)
    }

    const closeModal = () => {
        setOpenUnityModal(false)
        setOpenDestinatioModal(false)
        props.filterUnity.cleanFilter()
    }

    const handleCloseUnity = () => {
        closeModal()
        props.setUnityToDestination()
        /* setOldTypeDestination(DestinationType.UNITY) */
    }

    const handleEditUnity = () => {
        setOpenUnityModal(true);
        props.setDestination(props.destinationFinal)
        props.filterUnity.cleanFilter()
        if(company.role !== Roles.ADMIN){
            props.filterUnity.onChange({target:{name:'onlyHierarchy',value:true}})
        }
        setOldTypeDestination(DestinationType.DESTINATION)
    }

    const handleMapClick = (lat: number, lng: number) => {
        props.setSelectedPoint({ lat, lng });
    };

    const handlePlaceSelect = (place: google.maps.places.PlaceResult | null) => {
        if (place?.geometry?.location) {
            props.setSelectedPoint({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
        }
    };

    const handleSetDestination = () => {
        props.setDestinationFinal({
            id: null,
            latitude: props.selectedPoint?.lat ?? 0,
            longitude: props.selectedPoint?.lng ?? 0,
            name: /* String(props.dataDestination.title) */value,
            type: DestinationType.DESTINATION
        })
        closeModal()
        /* setOldTypeDestination(DestinationType.DESTINATION) */
    }

    const handleEditDestination = (create: boolean) => {
        setOpenDestinatioModal(true);

        /* props.setDestination(undefined) */
        if (create) {
            setOldTypeDestination(DestinationType.UNITY)
            //props.handleDataDestination({})
            setValue('')
            props.setSelectedPoint(null)
        } else {
            setOldTypeDestination(DestinationType.DESTINATION)
        }
    }

    useEffect(() => {
        let errorMessage = ''
        /* const destinationTimeZoneCode = props.destinationFinal?.timeZone?.code; */

        if (props.destinationFinal?.timeZone) {
            const normalizedFrom = dayjs(props.defaultValues.from).tz(localTimeZone, true);
            const normalizedTo = dayjs(props.defaultValues.to).tz(localTimeZone, true);
            if (normalizedTo.isBefore(normalizedFrom.add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
        } else {
            if (dayjs(props.defaultValues.to).isBefore(dayjs(props.defaultValues.from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
        }

        /* if (dayjs(props.defaultValues.to).isBefore(dayjs(props.defaultValues.from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') } */

        setErrors(prev => ({
            ...prev,
            to: errorMessage
        }))
    }, [props.defaultValues])

    /* useEffect(() => {

        if (!(oldTypeDestination == DestinationType.DESTINATION && props.destinationFinal?.type == DestinationType.DESTINATION)) {

            const destinationTimeZoneCode = toUnitTimeZone(new Date(), props.destinationFinal?.timeZone?.value);

            if (props.idToEdit == 0) {
                if (props.destinationFinal?.timeZone) {
                    props.setDefaultValues({ from: dayjs(destinationTimeZoneCode), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs(destinationTimeZoneCode) })
                } else if (!props.destinationFinal?.timeZone) {
                    props.setDefaultValues({ from: dayjs(), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs() })
                }
            } else {
                if (editInEdit) {
                    if (props.destinationFinal?.timeZone) {
                        props.setDefaultValues({ from: dayjs(destinationTimeZoneCode), to: null })
                        props.handleChangeCrud({ name: 'from', date: dayjs(destinationTimeZoneCode) })
                    } else if (!props.destinationFinal?.timeZone) {
                        props.setDefaultValues({ from: dayjs(), to: null })
                        props.handleChangeCrud({ name: 'from', date: dayjs() })
                    }
                }
            }

        }

    }, [props.destinationFinal]); */

    useEffect(() => {
        const destinationTimeZoneCode = toUnitTimeZone(new Date(), props.destinationFinal?.timeZone?.value);


        if (!(oldTypeDestination == DestinationType.DESTINATION && props.destinationFinal?.type == DestinationType.DESTINATION)) {

            if (props.destinationFinal?.timeZone) {
                const isMinor = dayjs(props.defaultValues.from).isBefore(dayjs(destinationTimeZoneCode))
                if (isMinor) {
                    props.setDefaultValues({ from: dayjs(destinationTimeZoneCode).add(1, 'minute'), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs(destinationTimeZoneCode).add(1, 'minute') })
                }
            } else {
                const isMinor = dayjs(props.defaultValues.from).isBefore(dayjs())
                if (isMinor) {
                    props.setDefaultValues({ from: dayjs().add(1, 'minute'), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs().add(1, 'minute') })
                }
            }

        }




    }, [props.destinationFinal]);


    return (
        <Box sx={styles.optionsContainer}>
            <Box sx={[styles.displayFlex, styles.containerActivity]} className="gp4">
                <Box sx={styles.displayFlex} className="gp2">
                    <Typography sx={styles.title}>{t('loogbook.titles.activity')}</Typography>
                    <DinamicForm input={Object.values(props.inputActivity)} values={props.dataActivity} onChange={props.onChangeCrud} />
                </Box>
                <Box sx={styles.displayFlex} className="gp2">
                    <Typography sx={styles.title}>{t('loogbook.titles.destinationRequired')}</Typography>
                    {!!props.destinationFinal ? (
                        <Box sx={styles.displayFlex} className="gp2">
                            <Box sx={styles.detinationContainer}>
                                <Box>
                                    <Typography className="bold">{t('general.tags.name')}</Typography>
                                    <Typography>{props.destinationFinal.name}</Typography>
                                </Box>
                                <Box sx={styles.lattitudeContainer}>
                                    <Box className="wdth">
                                        <Typography className="bold">{t('general.tags.latitude')}</Typography>
                                        <Typography>{props.destinationFinal.latitude}</Typography>
                                    </Box>
                                    <Box className="wdth">
                                        <Typography className="bold">{t('general.tags.longitude')}</Typography>
                                        <Typography>{props.destinationFinal.longitude}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={styles.buttonWithoutBorder}>
                                <Button
                                    onClick={() => {
                                        if (props.idToEdit !== 0 && props.destinationFinal?.type === DestinationType.UNITY) {
                                            setEditInEdit(true)
                                        }
                                        if (props.destinationFinal) {
                                            props.destinationFinal.type === DestinationType.DESTINATION
                                                ? handleEditDestination(false)
                                                : handleEditUnity();
                                        } else {
                                        }
                                    }}
                                >
                                    {props.destinationFinal.type == DestinationType.DESTINATION ? t('loogbook.buttons.editDestination') : t('loogbook.buttons.editUnity')}
                                </Button>
                                <Button
                                    onClick={() => {
                                        setEditInEdit(true)
                                        if (props.destinationFinal) {
                                            props.destinationFinal.type === DestinationType.UNITY
                                                ? handleEditDestination(true)
                                                : handleEditUnity()
                                        } else {
                                        }
                                    }}
                                >{props.destinationFinal.type == DestinationType.DESTINATION ? t('loogbook.buttons.selectUnity') : t('loogbook.buttons.createDestination')}</Button>
                            </Box>
                        </Box>
                    ) : (
                        <Box sx={styles.conteinerButton}>
                            <Button onClick={() => { handleEditUnity() }}>{t('loogbook.buttons.selectUnity')}</Button>
                            <Button onClick={() => { handleEditDestination(true) }}>{t('loogbook.buttons.createDestination')}</Button>
                        </Box>
                    )}
                </Box>
                <Box sx={styles.displayFlex} className="gp2">
                    <Typography sx={styles.title}>{t('loogbook.titles.programming')}</Typography>
                    <DinamicForm input={Object.values(props.inputActivityCheck)} values={props.dataActivity} onChange={props.onChangeCrud} />
                    {!props.dataActivity?.free &&
                        <Box sx={styles.containerDate}>
                            <DateModalSimple
                                timeZone={props?.destinationFinal?.timeZone?.code ?? localTimeZone}
                                setIsToBiggerThanFrom={props.setIsToBiggerThanFrom}
                                buttonTitle="Desde *"
                                defaultDate={props.defaultValues.from}
                                errorMsg={errors?.from}
                                error={!!(errors.from)}
                                getDate={(date) => { props.getDate(date, 'from') }}
                                payload={{ max: props.defaultValues.to, min: props.destinationFinal?.timeZone ? dayjs(toUnitTimeZone(new Date(), props.destinationFinal?.timeZone?.value)) : dayjs(), is: { start: true, startLower: props.isToBiggerThanFrom } }}
                                title='SELECCIÓN DE FECHA DE INICIO' name="from"
                            />

                            <DateModalSimple
                                timeZone={props?.destinationFinal?.timeZone?.code ?? localTimeZone}
                                setIsToBiggerThanFrom={props.setIsToBiggerThanFrom}
                                buttonTitle="Hasta *"
                                defaultDate={props.defaultValues.to}
                                errorMsg={errors?.to}
                                error={!!(errors.to)}
                                getDate={(date) => { props.getDate(date, 'to') }}
                                /* payload={{ min: props.defaultValues.from ?? dayjs(), is: { end: true, endBigger: props.isToBiggerThanFrom } }} */
                                payload={{ min: dayjs(props.defaultValues.from).tz(localTimeZone, true) ?? dayjs(), is: { end: true, endBigger: props.isToBiggerThanFrom } }}
                                title='SELECCIÓN DE FECHA DE FIN' name="to" />
                        </Box>
                    }
                </Box>

                <Button disabled={disableActivityForm || !props.destinationFinal || (!props.dataActivity?.free && !props.defaultValues.to) || (!props.dataActivity?.free && !!(errors.to))} onClick={props.idToEdit == 0 ? handleAddActivity : handleEditActivity} variant="contained">{props.idToEdit == 0 ? t('general.add') : t('general.edit')}</Button>

                <InputModal
                    open={openUnityModal}
                    title={t('stores.filter.inputs.search')}
                    cancelText={t('general.cancel')}
                    buttonText={t('loogbook.buttons.select')}
                    disableButton={!props.destination}
                    back={closeModal}
                    next={handleCloseUnity}
                    children={<>
                        <Box sx={styles.filters}>
                            {!!props.filterUnity.counter && (<CustomeIconButton icon={icons('clean')} title={t('ToolTips.clearFilters')} iconButtonProps={{ sx: styles.cleanFilters, onClick: () => { props.filterUnity.cleanFilter() } }} />)}
                            <DinamicForm input={Object.values(props.inputFilterUnity)} values={props.filterUnity.filterData} onChange={props.filterUnity.onChange} />
                        </Box>

                        <Box sx={styles.table({ row: !!props.tableUnits.row.length })}>
                            <CustomTable
                                name={'Table'}
                                dontRefresh
                                column={props.tableUnits.column}
                                onClick={(e) => { props.handleRowClickUnity(e.checks[0]); }}
                                defaultChecks={[Number(props.destination?.id)]}
                                tableRadio
                                tableChecks
                                row={props.tableUnits.row}
                                selected={-1}
                                loader={props.loading.units}
                                serverSidePagination={{ page: props.filterUnity.paginationModel.page + 1, size: props.filterUnity.paginationModel.pageSize, totalPages: props.totalPages }}
                                handleChange={(page: number, pageSize: number) => {
                                    props.filterUnity.handlePagination({ page, pageSize })
                                }}
                            />
                        </Box>
                    </>}
                />

                <InputModal
                    open={openDestinatioModal}
                    title={props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.titles.editDestination') : t('loogbook.titles.createDestination')}
                    cancelText={t('general.cancel')}
                    buttonText={props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.titles.editDestination') : t('loogbook.titles.createDestination')}
                    back={closeModal}
                    next={handleSetDestination}
                    disableButton={disableName || !props.selectedPoint}
                    children={<>
                        {/* <Box sx={styles.filters}>
                            <DinamicForm input={Object.values(props.inputDestination)} values={props.dataDestination} onChange={props.onChangeDestination} />
                        </Box> */}
                        <Box sx={styles.map}>
                            <MapActivity
                            defaultCenter={{ lat: props.selectedPoint ? props.selectedPoint.lat : 37.7749, lng: props.selectedPoint ? props.selectedPoint.lng : -122.4194 }}
                            defaultZoom={14}
                            selectedPoint={props.selectedPoint}
                            onMapClick={handleMapClick}
                            onPlaceSelect={handlePlaceSelect}
                            setDisableName={setDisableName}
                            value={value}
                            setValue={setValue}
                        /> 
                        </Box>
                    </>
                    }
                />
            </Box>
        </Box>
    )
}